import React from 'react';
import Loader from '../loader';
import { getCompanies } from '../../services/customer';
import AdminControllerEntity from './AdminControllerEntity';
import { addNotification } from '../../action/notificationAction';
import { SearchBox } from '../components/SearchBox';
import TemplateModal from '../template/templateModal';
import ThemeDesignerModal from '../themeDesigner/ThemeDesignerModal';

/**Component which handles retrieving the list of companies
 * and handling the all the list functionality needed
 */
export default class AdminController extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            companies: [],
            searchPhrase: "",
            isShowThemeModal: false
        };
    };

    componentDidMount() {
        // getPublishedTrees();
    }
    componentWillMount() {
        this.loadingSwapper();
        getCompanies().then((data) => {
            this.setState({ companies: data.companies.sort(this.sortArray) }, () => {
                this.loadingSwapper();
            });
        }).catch((e) => {
            if (e === 401) {
                addNotification({ status: "fail", message: "You are not a admin, do not try again" });
                this.props.notAdmin();
            } else {
                this.loadingSwapper();
                addNotification({ status: "fail", message: e });
            }
        });
    }
    componentWillUnmount() {

    }
    /**Sorts by stage number */
    sortArray(a, b) {
        if (a.stage < b.stage) {
            return -1;
        }
        if (a.stage > b.stage) {
            return 1;
        }
        return 0;
    }
    /**Updates the stage number */
    updateStage = (stage, id) => {
        const filteredComps = this.state.companies.filter((comps) => {
            return comps.id === id;
        });
        if (filteredComps.length === 0) {
            return;
        } else {
            const index = this.state.companies.indexOf(filteredComps[0]);
            let companies = this.state.companies;
            companies[index] = { ...companies[index], stage: stage };
            this.setState({ companies: companies.sort(this.sortArray) });
        }
    };
    /**Swaps the loading */
    loadingSwapper = () => this.setState((prevState) => ({ loading: !prevState.loading }));
    /**Maps out the company array and handles search functionality */
    mappedCompanies = () => {
        const { companies, searchPhrase } = this.state;
        if (searchPhrase.length > 0) {
            return companies.filter((comps) => {
                if (comps.company.toLowerCase().includes(searchPhrase.toLowerCase())) {
                    return true;
                }
                return false;
            }).map((company) => {
                return <AdminControllerEntity key={company.id} onAddTheme={this.onShowThemeModal}
                    onAddTemplate={this.onShowModal} company={company} updateStage={this.updateStage} />;
            });
        } else {
            return companies.map((company) => {
                return <AdminControllerEntity key={company.id} onAddTheme={this.onShowThemeModal}
                    onAddTemplate={this.onShowModal} company={company} updateStage={this.updateStage} />;
            });
        }
    };
    /**On search change handler */
    onSearchChange = (ev) => {
        const input = ev.target.value;
        this.setState({ searchPhrase: input });
    };
    onShowThemeModal = (companySelectedId) => this.setState({ isShowThemeModal: true, modalSelectionID: companySelectedId });
    onHideModal = () => this.setState({ isShowTemplateModal: false, modalSelectionID: undefined, isShowThemeModal: false });
    onShowModal = (companySelectedId) => this.setState({ isShowTemplateModal: true, modalSelectionID: companySelectedId }, () => console.log(this.state));
    render() {
        const { loading, companies, isShowTemplateModal, isShowThemeModal, modalSelectionID } = this.state;
        if (loading) {
            return <Loader />;
        }
        return (
            <div>
                <SearchBox onChange={this.onSearchChange} />
                {companies.length > 0 ? this.mappedCompanies() : <p>There currently are no customers in the list</p>}
                <ThemeDesignerModal isShow={isShowThemeModal} selectedCompanyID={modalSelectionID} handleClose={this.onHideModal} />
                <TemplateModal isShow={isShowTemplateModal} selectedCompanyID={modalSelectionID} handleClose={this.onHideModal} />
            </div >
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/adminController/AdminController.js